<template lang="html">

  <el-cascader
    collapse-tags
    clearable
    class="inpText"
    size="medium"
    v-model="id"
    :placeholder="plaText"
    :options="selectArr"
    :props="{value:'id',label:'name',children:'dataDictionarys',multiple:moreSelect,emitPath:false }"
    @change="selectChange">
  </el-cascader>

</template>

<script>
import { treeSeek } from "@/api/pgMent/dictMent";
export default {
    name:'treeSelect',
    props:['code','selectId','paramsKey','plaText','moreSelect'],
    watch:{
         selectId:function(e){
             if(!this.moreSelect&&e){
                console.log(this.selectArr,e);
                var tids=this.familyTree(this.selectArr,e);
                var ids=[];
                for(var i=tids.length-1;i>=0;i--){
                    ids.push(tids[i].id);
                }
                this.id = ids;
                console.log(this.code,this.id );
             }else{
                 this.id=e.split(',');
             }
            
         }
    },
    data(){
        return{
            id:[],
            selectArr:[],
            dectMap:{}
        }
    },
    methods:{
        familyTree (arr1, id) {
            var temp = []
            var forFn = function (arr, id) {
                for (var i = 0; i < arr.length; i++) {
                    var item = arr[i]
                    if (item.id === id) {
                        temp.push(item)
                        forFn(arr1, item.parentId)
                        break
                    } else {
                        if (item.dataDictionarys) {
                            forFn(item.dataDictionarys, id)
                        }
                    }
                }
            }
            forFn(arr1, id)
            return temp
        },
        selectChange:function(e){
            console.log(e);
            var vues = this
            var id = '';
            if(vues.moreSelect){
                id = e.join(',')
            }else{
                if(Array.isArray(e)&&e.length>0){
                    id= e.join(',')
                }else{
                    id=e;
                }
            };
            var name='';
            if(Array.isArray(e)){
                for(var i=0;i<e.length;i++){
                    if(i==e.length-1){
                        name+=vues.dectMap[e[i]];
                    }else{
                        name+=vues.dectMap[e[i]]+"/";
                    }
                }
            }else{
                name+=vues.dectMap[e];
            }
            
            var ret={
                id:id,
                name:name,
                paramsKey:this.paramsKey
            }
            this.$emit('selectChange',ret)
        },
        mapCreate(arr){
            let vues = this;
            
            arr.forEach(item => {
                vues.dectMap[item.id] = item.name;
                if(item.dataDictionarys.length > 0){
                   vues.mapCreate(item.dataDictionarys);
                }else{
                   delete item.dataDictionarys;
                }
            })
        },
    },



    created(){
        let vues = this;
        
        treeSeek({code:this.code}).then(res => {
            var unFormate = res.dataDictionaryTreeModules[0].dataDictionarys;
            vues.mapCreate(unFormate);
            vues.selectArr = unFormate;
            if(!this.moreSelect&&vues.selectId){
                var tids=vues.familyTree(vues.selectArr,vues.selectId);
                var ids=[];
                for(var i=tids.length-1;i>=0;i--){
                    ids.push(tids[i].id);
                }
                vues.id=ids;
            }else{
                if(vues.selectId){
                    vues.id=vues.selectId.split(',');
                }else{
                    vues.id=[];
                }
                
            }
        })
    }

}
</script>

<style lang="css" scoped>



</style>



// WEBPACK FOOTER //
// dcTreeSelect.vue?79feb73e